import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/layout'

// 公共路由
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/Login/index'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/Register/index'),
    hidden: true
  },
  {
    path: '/forgotPwd',
    component: () => import('@/views/ForgotPwd/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404'),
    hidden: true
  },
  {
    path: '/noPermission',
    component: () => import('@/views/Error/noPermission'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/Home/index'),
        name: 'Index',
        meta: { title: '快速操作指引', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/user/index'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  {
    path: '/partnershare',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'overview',
        component: () => import('@/views/Partnershare/index'),
        name: 'Partnershare',
        meta: { title: '推广返佣', icon: 'user' }
      },
      {
        path: 'apply',
        component: () => import('@/views/Partnershare/apply'),
        name: 'PartnershareApply',
        meta: { title: '推广返佣', icon: 'user' }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'classify',
        component: () => import('@/views/StoreClassify/index'),
        name: 'Classify',
        meta: { title: '智能体商店分类', icon: 'user' }
      },
    ]
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'storeManage',
        component: () => import('@/views/StoreManage/index'),
        name: 'StoreManage',
        meta: { title: '智能体商店管理', icon: 'user' }
      },
    ]
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'store',
        component: () => import('@/views/Store/index'),
        name: 'Store',
        meta: { title: '智能体商店', icon: 'user' }
      },
    ]
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'myAgent',
        component: () => import('@/views/MyAgent/index'),
        name: 'MyAgent',
        meta: { title: '我的智能体', icon: 'user' }
      },
    ]
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'knowledge',
        component: () => import('@/views/Knowledge/index'),
        name: 'Knowledge',
        meta: { title: '企业知识库', icon: 'user' }
      },
    ]
  }
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', 
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
